import React, { useEffect, useState } from 'react';
import { ReactComponent as Call } from '../assets/images/call_icon.svg';
import { ReactComponent as Message } from '../assets/images/chat_icon.svg';
import { ReactComponent as Whatsapp } from '../assets/images/whatsapp_icon.svg';
import { ReactComponent as Email } from '../assets/images/email_icon.svg';
import { isAuthenticated } from '../utilities';
// import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';

function NeedHelpModal(props) {
  const { visible, setVisible, isWebinar } = props;
  const { domainDetails } = useSelector((state) => state.listings);
  const [isWebinarPage, setIsWebinarPage] = useState();

  const userDetails = {};

  useEffect(() => {
    if (window.location.href.includes('/live/')) {
      setIsWebinarPage(true);
    }
  }, []);

  const handleOpenLiveChat = () => {
    if (isAuthenticated()) {
      if (userDetails && userDetails.users) {
        window.LC_API.set_visitor_name(`${userDetails.users.firstName} ${userDetails.users.lastName}`);
        window.LC_API.set_visitor_email(userDetails.users.email);
      }
    }
    window.LC_API.open_chat_window();
    setVisible(false);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Modal title='' footer={null} visible={visible} onOk={handleOk} onCancel={handleCancel} className='quiz_model' width='785px'>
      <div className={'helpModal'}>
        <img className={'helpModal_image'} src={'https://omnicuris-backend.s3-ap-southeast-1.amazonaws.com/enterprise/icons/help-modal-image.png'} />
        <p className={'helpModal_title'}>Need Help?</p>
        <p className={'helpModal_subTitle'}>We are a click away. Feel free to drop a message and we'll get back to you soon!</p>
        <div className={'contactContainer'}>
          <div onClick={() => (window.location.href = `tel:+91${domainDetails && domainDetails.helpMobileNumber ? domainDetails.helpMobileNumber : '8061932737'}`)} className={'iconDiv'}>
            <Call className={'call_icon'} />
            <div className={'contactTitle'}>Call us</div>
          </div>
          {/* {isWebinar || isWebinarPage ? null : (
            <div onClick={handleOpenLiveChat} className={'iconDiv'}>
              <Message className={'call_icon'} />
              <div className={'contactTitle'}>Live Chat</div>
            </div>
          )} */}
          {/* <div onClick={() => window.open('https://api.whatsapp.com/send?phone=+917026666042')} className={'iconDiv'}>
            <Whatsapp className={'call_icon'} />
            <div className={'contactTitle'}>WhatsApp</div>
          </div> */}
          <div onClick={() => window.open(`mailto:${domainDetails && domainDetails.helpEmail ? domainDetails.helpEmail : 'info@thedoc.pro'}?subject=Need Help`)} className={'iconDiv'}>
            <Email className={'call_icon'} />
            <div className={'contactTitle'}>Email us</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default NeedHelpModal;
